import { action, observable } from "mobx";
import { ChatViewStore } from "./ChatViewStore";
import { localizationService } from "@state/services";
import { BetSlipInteractionTypeEnum } from "@data-types/analytics-tracker/BetSlipInteractionTypeEnum";
import { BetSlipShareDetails } from "../my-bets/BetSlipShareDetailsStore";
import { BetSlipShare } from "@models/BetSlipShare";
import { analyticsTracker } from "@utils/analytics";

export class ChatBetSlipShareHandler {
	@observable activePopupBet: BetSlipShare | null = null;

	chatViewStore: ChatViewStore;
	BetSlipShareDetails: BetSlipShareDetails;

	constructor(chatViewStore: ChatViewStore) {
		this.chatViewStore = chatViewStore;
	}

	initializeBetDetailsStore() {
		this.BetSlipShareDetails = new BetSlipShareDetails(
			this.chatViewStore.rootStore
		);
	}

	async openChatSharedSlipPopup(betSlipNr: string) {
		await this.BetSlipShareDetails.getSharedBetSlipDetails(betSlipNr);

		this.setActivePopupBet(this.BetSlipShareDetails.bet);

		if (!this.BetSlipShareDetails.bet) {
			this.onDispose();
			this.chatViewStore.rootStore.notificationStore.error(
				localizationService.t("mybets:SHARE.BET_SLIP_NOT_FOUND")
			);
		}
	}

	addToSlip(bet: BetSlipShare) {
		analyticsTracker.trackBetSlipSharePopupAdd(
			BetSlipInteractionTypeEnum.ChatBetSlipShare,
		);
		this.chatViewStore.rootStore.betSlipStore.useBetSlip({
			...bet,
		});
		this.onDispose();
	}

	@action.bound
	setActivePopupBet(bet: BetSlipShare | null) {
		this.activePopupBet = bet;
	}

	@action.bound
	onDispose() {
		this.activePopupBet = null;
		if (this.BetSlipShareDetails) {
			this.BetSlipShareDetails.onDispose();
		}
	}
}
